import { CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export const CustomDialog = (props) => {

    const handleCloseWaitingDialog = (_, reason) => {
        if (reason !== 'backdropClick') {
        }
    };

    return (
        <>
        <Dialog
            open={props.show}
            onClose={handleCloseWaitingDialog}
            disableEscapeKeyDown={true}
            >
            <DialogTitle 
                sx={{
                    marginX: 2,
                    alignItems: "center",
                }}
            >
                {props.title}
            </DialogTitle>
            <DialogContent 
                sx={{
                    marginBottom: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }
            }>
                { props.content && <p>{props.content}</p>}
                <CircularProgress thickness={ 1 } />
            </DialogContent>
        </Dialog>
        </>
    );
};
